import script from "./ImageWrap.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageWrap.vue?vue&type=script&setup=true&lang=js"

import "./ImageWrap.vue?vue&type=style&index=0&id=2d28f6a7&scoped=true&lang=css"

import exportComponent from "/var/www/levsha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d28f6a7"]])

export default __exports__